export const ALARM = 'alarm'
export const CANCEL = 'cancel'
export const COMPLETE = 'complete'
export const ERROR = 'error'
export const PROGRESS = 'progress'
export const READY = 'ready'
export const REMOVED = 'removed'
export const SELECTED = 'selected'
export const UPDATE = 'update'
